import Vue from 'vue'

import 'normalize.css/normalize.css'// A modern alternative to CSS resets

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import locale from 'element-ui/lib/locale/lang/zh-CN' // lang i18n
import VCharts from 'v-charts'
import Distpicker from 'v-distpicker'
import echarts from 'echarts'
// import from 'element-china-area-data'

import '@/styles/index.scss' // global css

import App from './App'
import router from './router'
import store from './store'

import {resize} from './utils/rem'

import lodash from 'lodash'
 
Vue.prototype.$lodash = lodash


import '@/icons' // icon
import '@/permission' // permission control

var HighCharts = require('highcharts')
// 在 HighCharts 加载之后加载功能模块
require('highcharts/modules/sankey')(HighCharts)
require('highcharts/modules/organization')(HighCharts)

Vue.use(ElementUI, { locale })
Vue.use(VCharts)
Vue.prototype.$echarts = echarts
Vue.component('v-distpicker', Distpicker)

Vue.directive('inputFloat', {
  bind(el, binding, vnode) {
    let input = vnode.elm;
    if (input.tagName !== 'INPUT') {
      input = input.querySelector('input');
    }
    if (!input) return;
    input.addEventListener('compositionstart', () => {
      vnode.inputLocking = true;
    });
    input.addEventListener('compositionend', () => {
      vnode.inputLocking = false;
      input.dispatchEvent(new Event('input'));
    });
    input.addEventListener(
      'input',
      e => {
        e.preventDefault(); // 阻止掉默认的change事件
        if (vnode.inputLocking) {
          return;
        }
        let oldValue = input.value;
        let newValue = input.value;
        newValue = newValue.replace(/[^\d.]/g, '');
        newValue = newValue.replace(/^\./g, '');
        newValue = newValue
          .replace('.', '$#$')
          .replace(/\./g, '')
          .replace('$#$', '.');
        const decimal = Number(binding.value) || 3; // 默认两位小数
        const reg = new RegExp(`^(\\-)*(\\d+)\\.(\\d{${decimal}}).*$`);
        newValue = newValue.replace(reg, '$1$2.$3');
        if (newValue) {
          let arr = newValue.split('.');
          newValue = Number(arr[0]) + (arr[1] === undefined ? '' : '.' + arr[1]); // 去掉开头多余的0
        }
        // 判断是否需要更新，避免进入死循环
        if (newValue !== oldValue) {
          input.value = newValue;
          input.dispatchEvent(new Event('input')); // 通知v-model更新
        }
      },
      true,
    );
    // input 事件无法处理小数点后面全是零的情况 因为无法确定用户输入的0是否真的应该清除，如3.02。放在blur中去处理
    input.addEventListener('blur', () => {
      let oldValue = input.value;
      let newValue = input.value;
      if (newValue) {
        newValue = Number(newValue).toString();
      }
      // 判断是否需要更新，避免进入死循环
      if (newValue !== oldValue) {
        input.value = newValue;
        input.dispatchEvent(new Event('input')); // 通知v-model更新
      }
    });
  },
});




Vue.config.productionTip = false
resize(Vue)
new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js